interface Props {
  message: string;
  detail?: string;
  tone?: 'success' | 'info' | 'error';
  onClose: () => void;
}

const tones = {
  success: { icon: 'ri-checkbox-circle-fill', color: 'text-primary-600', bar: 'bg-primary-500' },
  info: { icon: 'ri-information-fill', color: 'text-secondary-600', bar: 'bg-secondary-500' },
  error: { icon: 'ri-error-warning-fill', color: 'text-rose-600', bar: 'bg-rose-500' },
};

export default function Toast({ message, detail, tone = 'success', onClose }: Props) {
  const t = tones[tone];
  return (
    <div className="fixed bottom-6 right-6 z-50 w-[340px] overflow-hidden rounded-lg border border-background-200 bg-background-50">
      <div className="flex gap-3 p-4">
        <i className={`${t.icon} ${t.color} mt-0.5 text-lg`} />
        <div className="min-w-0 flex-1">
          <p className="text-[13px] font-semibold text-foreground-950">{message}</p>
          {detail && <p className="mt-0.5 text-xs leading-4 text-foreground-500">{detail}</p>}
        </div>
        <button
          type="button"
          onClick={onClose}
          aria-label="Dismiss notification"
          className="cursor-pointer text-foreground-400 transition-colors hover:text-foreground-700"
        >
          <i className="ri-close-line text-base" />
        </button>
      </div>
      <div className={`h-0.5 w-full ${t.bar}`} />
    </div>
  );
}